module.exports = __webpack_public_path__ + "static/media/Background_Bottom.be4968dd.webp";